<template>
  <div class="slider">
    <div class="item">
      <div
        class="slider-bg"
        v-bind:style="{
          'background-image':
            'url(' + require('../../assets/image/faq.jpg') + ')'
        }"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      sliderImage: null,
      sliderIndex: -1,
      start: false
    };
  }
};
</script>
<style scoped>
.slider,
.slider .item,
.slider .slider-bg {
  width: 100%;
  float: left;
  height: 400px;
}

.slider {
  padding: 0 !important;
  margin-bottom: 50px;
}

.slider .item,
.slider .slider-bg {
  overflow: hidden;
}

.slider .slider-bg {
  background-position: top center;
  background-size: cover;
  animation-duration: 8s;
  animation-timing-function: linear;
}

.slider .slider-bg::after {
  content: "";
  width: 100%;
  height: 400px;
  position: absolute;
  top: 0;
  left: 0;
  background: #292929;
  opacity: 0.7;
}
</style>
